import React from 'react'
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import ResultRank from "components/presentation/ResultRank"
import { ColumnBib, ColumnName, ColumnNoc, ColumnMove, ColumnExpander, ColumnRecords } from "components/common/TableColumns"
import { ColumnIntermediateRank } from "components/common/TableColumnsIntermediates"



function getCurrent(props) {
  return (
    props.currentSplit === '999' ? props.finalSplit : props.currentSplit
  )
}

export function ColumnRank({
  disableSort = false,
  className = 'text-end',
  headerClassName = 'text-end w-5',
  label = 'HeaderRank'
}) {

  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => {
        let val = findArray(props?.resultAnalysis?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrent(props)] })?.er_sortorder
        return (val ? val : null)
      },
      sortType: "absoluteOrderNumber",
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      id: 'Rank'
    }
  )
}

export function TableColumns(columnsAdded) {
  //let numCols = findArray(columnsAdded, { ei_code: ['INTERMEDIATES_TOTAL'] })?.ei_value;

  let numCols
  let lastIntermediateArray = columnsAdded?.filter(item => item?.ei_code === "INTERMEDIATE");
  if (Array.isArray(lastIntermediateArray)) {
    numCols = Math.max.apply(Math, lastIntermediateArray.map(function (item) {
      return Number(item?.ei_pos);
    }));
  }
  //numCols = numCols ? numCols : lastIntermediate



  //Create Columns splits
  let columnsExt = columnsAdded.filter(row => row.ei_code === 'INTERMEDIATE').map((val) => {
    const filters = {
      er_code: ['INTERMEDIATE'],
      er_pos: [val.ei_pos]
    };

    let _header = <>{val.ei_value}&nbsp;<Label data="LabelMeters" /></>
    _header = Number(val.ei_pos) === Number(numCols) ? val.ei_value : _header

    return (
      {
        Header: _header,
        accessor: (props) => {
          let extendedResult = findArray(props?.resultAnalysis?.extendedResults, filters);
          return (
            extendedResult ? Number(extendedResult.er_sortorder) : null
          )
        },
        sortType: "absoluteOrderNumber",
        disableSortBy: false,
        isVisible: false,
        columnIndex: val.ei_pos,
        id: 'ResultEx' + val.ei_pos,
        className: 'text-end',
        headerClassName: 'text-end w-10',
        Cell: (props) => {
          let extendedResult = findArray(props.cell.row.original?.resultAnalysis?.extendedResults, filters);
          //Used to get values from DT_RESULT_ANALYSIS
          let mainResult = props.cell.row.original?.resultAnalysis?.extendedResults.find(er => er?.er_type === 'FAKE' && er?.er_code === 'MAIN_RESULT')?.er_value
          mainResult = mainResult ? JSON.parse(mainResult) : {};
          let isUncheckedAnalysis = mainResult?.unchecked

          let isUnchecked = isUncheckedAnalysis
            ? isUncheckedAnalysis === 'Y' && (Number(val.ei_pos) === Number(numCols))
            : props.cell.row.original?.unchecked === 'Y' && (Number(val.ei_pos) === Number(numCols))

          if (extendedResult) {
            return (
              (Number(val.ei_pos) === Number(numCols))
                ? extendedResult.er_value && isUnchecked
                  ? '(' + extendedResult.er_value + ')'
                  : extendedResult.er_value
                : <ResultRank result={extendedResult.er_value} rank={extendedResult.er_rank} isUnchecked={isUnchecked} />

            )
          }
        }

      }
    )
  })

  return (
    [
      ColumnIntermediateRank({ type: 'resultAnalysis' }),
      ColumnMove({}),
      ColumnBib({ label: 'HeaderBibNoR', headerClassName: 'text-end w-5' }),
      ColumnNoc({}),
      ColumnName({}), //ColumnName({ label: 'HeaderBib' }),
      ...columnsExt,
      ColumnRecords({}),
      ColumnExpander({ type: 'resultAnalysis' })
    ]
  )
}

export default TableColumns
